<template>
  <div class="wrapper">
    <email-cobranca-view ref="cobrancaView"></email-cobranca-view>
    <h5>
      Cobrança de lotes
    </h5>
    <div class="m-b">Você visualizará nesta lista somente os lotes passíveis de cobrança, para visualizar todos os lotes acesse a seção principal do leilão</div>

    <div class="filters row font-11 justify-between">
      <div class="col text-grey-7" style="max-width: 70px; line-height: 20px">
        <!--{{table.serverPagination.rowsNumber}} lote{{table.serverPagination.rowsNumber > 1 ? 's' : ''}}-->
        {{filteredServerData.length}} lote{{filteredServerData.length > 1 ? 's' : ''}}
        <u-btn @click="load" icon="refresh" round rounded flat size="xs" :loading="table.loading" />
      </div>
      <div class="col m-l-lg" style="line-height: 20px; max-width: 500px">
        <div class="row">
          <div class="col">
            <erp-checkbox class="flex no-wrap items-center m-r" v-model="table.filters.semCobranca">
              <label class="no-select text-nowrap font-bold">
                <span class="m-l-xs text-nowrap">Sem cobrança</span>
              </label>
            </erp-checkbox>

            <erp-checkbox class="flex no-wrap items-center m-r" v-model="table.filters.comCobranca">
              <label class="no-select text-nowrap font-bold">
                <span class="m-l-xs text-nowrap">Cobrança enviada</span>
              </label>
            </erp-checkbox>

          </div>
        </div>
      </div>
      <div class="col" style="max-width: 140px">
        <erp-s-field
            class="font-10"
            view="lr"
            label="Buscar:"
        >
          <helper-input-btn>
            <erp-input simple-border v-model="table.filters.pesquisa" />
            <a class="m-l-xs text-black">IR</a>
          </helper-input-btn>
        </erp-s-field>
      </div>
      <div class="col m-l m-b-n" style="max-width: 110px; text-align: right">
        <u-btn @click="listOptions" label="Configurar lista" no-caps size="sm" color="grey-4" class="text-grey-8" />
      </div>
    </div>
    <div class="erp-list no-pad">
      <u-table
          ref="table"
          color="primary"
          :data="filteredServerData"
          :columns="table.columns"
          :visible-columns="visibledColumns"
          :filter="table.busca"
          row-key="id"
          :pagination.sync="table.serverPagination"
          @request="request"
          selection="multiple"
          :selected.sync="table.selected"
          :loading="table.loading"
          class="erp-table"
          :rows-per-page-options="[100, 300, 500]"
      >
        <!--<template slot="top-right" slot-scope="props">
        </template>-->
        <u-tr slot="header" slot-scope="props">
          <u-th auto-width>
            <u-checkbox
                v-model="props.selected"
                :indeterminate="props.partialSelected"
                size="sm"
            />
          </u-th>
          <u-th v-for="col in props.cols" :key="col.name" :props="props">
            {{ col.label }}
          </u-th>
        </u-tr>

        <u-tr slot="body" slot-scope="props"
              :props="props">
          <u-td auto-width>
            <u-checkbox color="primary" v-model="props.selected" size="xs" />
          </u-td>
          <u-td key="lote" :props="props">
            <div>{{props.row.numero}}</div>
          </u-td>
          <u-td key="comitente" :props="props" class="uppercase td-limit l-130" :title="props.row.bem.comitente && props.row.bem.comitente.pessoa.name">
            {{props.row.bem.comitente && props.row.bem.comitente.pessoa.name}}
          </u-td>
          <u-td :title="props.row.descricao" class="td-limit l-130 uppercase" key="descricao"
                :props="props">
            {{props.row.descricao}}
          </u-td>
          <u-td key="valorMinimo" :props="props">
            R$ {{props.row.valorMinimo|moeda}}
          </u-td>
          <u-td key="arremate" :props="props">
            <span v-if="props.row.arremate">{{props.row.arremate.arrematante.apelido}}</span>
            <span v-else>-</span>
          </u-td>
          <u-td key="lances" :props="props">
            <div v-if="props.row.historicoLances"> <!-- TODO ? -->
              {{props.row.historicoLances.total}}
              <span v-if="props.row.historicoLances.atual" class="font-10 font-thin">
                (R$ {{props.row.historicoLances.atual.valor|moeda}})
              </span>
            </div>
            <div v-else-if="props.row.lances && props.row.lances.length">
              {{props.row.totalLances}}
              <span v-if="props.row.lances[0]" class="font-10 font-thin">
                (R$ {{props.row.lances[0].valor|moeda}})
              </span>
            </div>
            <div v-else>-</div>
          </u-td>
          <u-td class="text-uppercase" key="status" :props="props">
            <status-lote :lote="props.row" /> <!-- TODO: PENDENTE DE PAGAMENTO / PAGO -->
          </u-td>
          <u-td class="text-uppercase" key="cobranca" :props="props">
            <div class="status-envio">
<!--              <u-icon name="envelope" type="fa" class="m-r-xs" /> Não enviado-->
              <u-btn @click="$refs.cobrancaView.load(props.row.id)" size="xs" label="Não enviado" icon="envelope" icon-type="fa" icon-style="light" class="nao-enviado" />
            </div>
          </u-td>
          <u-td class="text-center" key="options" :props="props">
            <e-btn-table-options>
              <menu-options>
                <default-list-menu
                    @abrir="abrir(props.row)"
                    @abrirBem="abrirBem(props.row.bem.id)"
                    @removerLote="remover(props.row)"
                    :leilao="props.row" />
              </menu-options>
            </e-btn-table-options>
          </u-td>
          <context-menu-lote-item
              @abrir="abrir(props.row)"
              @abrirBem="abrirBem(props.row.bem.id)"
              @removerLote="remover(props.row)"
              :leilao="props.row" />
        </u-tr>
      </u-table>

<!--          v-if="table.selected.length > 0"-->
    </div>
  </div>
</template>

<script>
import {UCheckbox, UTable, UTd, UTh, UTr, LocalStorage} from 'uloc-vue'
import {EBtnTableOptions, ErpCheckbox, ErpSField, ErpInput, HelperInputBtn} from 'uloc-vue-plugin-erp'
import {listLotesCobranca as list} from '../../../../domain/leiloes/services'
import MenuOptions from '../../../layout/context-menu/context-window-options'
import DefaultListMenu from '../context/list-menu-lote'
import StatusLote from '../include/StatusLote'
import ContextMenuLoteItem from '../context/list-context-lote'
import loteWindow from '../../windows/lote'
import bemWindow from '../../../bem/windows/bem'
import AlteracaoStatusLoteMixin from '../include/AlteracaoStatusLoteMixin'
import listOptions from '../../windows/listOptions'
import DefaultMixin from '@/components/leiloes/mixin'
import EmailCobrancaView from '@/components/leiloes/components/cobranca/EmailCobrancaView'

let listStorage = LocalStorage.get.item('leilao.cobranca.list')
if (!listStorage) {
  listStorage = [
    {label: 'LT', name: 'lote', active: true, sortable: true, ordering: 1},
    {label: 'Comitente', name: 'comitente', active: true, sortable: true, ordering: 1},
    {label: 'Descrição', name: 'descricao', active: true, sortable: true, ordering: 1},
    {label: 'Mínimo', name: 'valorMinimo', active: true, sortable: true, ordering: 1},
    {label: 'Arremate', name: 'arremate', active: true, sortable: true, ordering: 1},
    {label: 'Lances', name: 'lances', active: true, sortable: true, ordering: 1},
    {label: 'Situação', name: 'status', active: true, sortable: true, ordering: 1},
    {label: 'Cobrança', name: 'cobranca', active: true, sortable: true, ordering: 1}
  ];
  LocalStorage.set('leilao.cobranca.list', listStorage)
}

let filters = {
  semCobranca: true,
  comCobranca: true,
  pesquisa: null
}

export default {
  name: 'ListaLotes',
  mixins: [AlteracaoStatusLoteMixin, DefaultMixin],
  inject: ['page', 'erplayout'],
  props: {
  },
  data () {
    return {
      leilao: this.page.leilao,
      listStorage: listStorage,
      table: {
        busca: '',
        serverData: [],
        serverPagination: {
          page: 1,
          rowsNumber: 10, // specifying this determines pagination is server-side
          rowsPerPage: 500
        },
        columns: listStorage.map(o => {
          return {
            ...o,
            field: o.name,
            required: o.required || null,
            align: 'left'
          }
        }).concat([
          {
            name: 'options',
            required: true,
            label: '',
            field: 'options',
            sortable: false
          }
        ]),
        filter: '',
        filters: JSON.parse(JSON.stringify(filters)),
        selected: [],
        loading: false
      }
    }
  },
  components: {
    EmailCobrancaView,
    ContextMenuLoteItem,
    StatusLote,
    MenuOptions,
    UTable,
    UTh,
    UTr,
    UTd,
    UCheckbox,
    EBtnTableOptions,
    DefaultListMenu,
    ErpCheckbox,
    ErpSField,
    ErpInput,
    HelperInputBtn
  },
  mounted () {
    this.page.setActive('cbl')
    console.log(this.leilao)
    this.load()
  },
  computed: {
    visibledColumns () {
      return this.listStorage.filter(item => {
        /*if (item.name === 'imagem') {
          return !this.table.filters.ocultarFotos
        }*/
        return item.active
      }).map(item => item.name)
    },
    filteredServerData () {
      let data = this.table.serverData.slice()

      let busca = this.table.filters.pesquisa
      if (busca && String(busca).length > 0) {
        console.log(busca)
        data = data.filter(lt => {
          return String(lt.descricao).toLowerCase().indexOf(busca) > -1 ||
            String(lt.bem.comitente.pessoa.name).toLowerCase().indexOf(busca) > -1
            || String(lt.numero).toLowerCase().indexOf(busca) > -1
            || String(lt.arremate.arrematante.apelido).toLowerCase().indexOf(busca) > -1
            || String(lt.arremate.arrematante.pessoa.name).toLowerCase().indexOf(busca) > -1
          // TODO: Implementar outros campos, principalmente arremate
        })
      }
      return data
      /*return this.table.serverData.slice().sort(function (a, b) {
        a = Number(a['numero'])
        b = Number(b['numero'])
        return (a === b ? 0 : a > b ? 1 : -1) * 1 // -1 = desc, 1 = asc
      })*/
    }
  },
  methods: {
    load () {
      this.request({
        pagination: this.table.serverPagination,
        filter: this.table.busca
      })
    },
    request ({pagination, filter}) {
      this.table.loading = true
      this.table.selected = []
      let _filter = this.filtros
      let filtros = encodeURI(`&sortBy=${pagination.sortBy}&descending=${pagination.descending}&search=${filter}`)

      list(this.leilao.id, pagination.rowsPerPage, pagination.page, filtros)
        .then(({data}) => {
          this.table.serverPagination = pagination
          this.table.serverPagination.rowsNumber = data.total
          this.table.serverData = data.result || []

          this.table.loading = false
          this.loadedData()
        })
        .catch(error => {
          this.loading = false
        })
    },
    abrir (lote) {
      this.loteWindow(lote)
    },
    abrirBem (id) {
      this.bemWindow(id)
    },
    loteWindow: loteWindow,
    bemWindow: bemWindow,
    listOptions: listOptions,
    loadedData () {
      this.$emit('loaded', this.table.serverData)
    },
    windowLoteEvents (wid) {
      this.$uloc.window.listen(wid, {
        update: (wid, lote) => {
          console.log('Updated lote event')
          // this.load()
          this.load()
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.status-envio{
  .nao-enviado{
    background-color rgb(239, 239, 239)
  }
}
</style>
